if (!customElements.get('collection-seo-faq-toggle')) {
  customElements.define(
    'collection-seo-faq-toggle',
    class CollectionSeoFaqToggle extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('[data-seo-content]');
        this.button = this.querySelector('[data-seo-toggle]');

        if (!this.content || !this.button) return;

        this.moreLabel = this.button.querySelector('[data-seo-toggle-label]').textContent;
        this.lessLabel = this.dataset.lessLabel;
        this.updateVisibility();
        this.button.addEventListener('click', this.toggle.bind(this));
        window.addEventListener('resize', this.updateVisibility.bind(this));
      }

      updateVisibility() {
        const collapsedHeight = parseInt(getComputedStyle(this.content).maxHeight, 10);
        const shouldShowToggle = this.content.scrollHeight > collapsedHeight + 1;
        this.button.classList.toggle('is-visible', shouldShowToggle);
      }

      toggle() {
        const isExpanded = !this.content.classList.contains('is-expanded');
        this.button.setAttribute('aria-expanded', isExpanded);
        this.button.querySelector('[data-seo-toggle-label]').textContent = isExpanded ? this.lessLabel : this.moreLabel;

        const expandedHeight = `${this.content.scrollHeight}px`;

        if (isExpanded) {
          const collapsedHeight = getComputedStyle(this.content).maxHeight;
          this.content.style.maxHeight = collapsedHeight;
          this.content.classList.add('is-expanded');
          requestAnimationFrame(() => {
            this.content.style.maxHeight = expandedHeight;
          });
        } else {
          this.content.style.maxHeight = expandedHeight;
          this.content.offsetHeight;
          this.content.classList.remove('is-expanded');
          requestAnimationFrame(() => {
            this.content.style.maxHeight = '';
          });
        }

        this.content.addEventListener(
          'transitionend',
          () => {
            if (isExpanded) this.content.style.maxHeight = '';
          },
          { once: true }
        );
      }
    }
  );
}

document.addEventListener('click', (event) => {
  const summary = event.target.closest('.collection-seo-faq__details > summary');
  if (!summary) return;

  const details = summary.parentElement;
  if (details.classList.contains('is-animating')) return;

  event.preventDefault();
  const startHeight = details.offsetHeight;
  const isOpening = !details.open;

  if (isOpening) details.open = true;

  const endHeight = isOpening ? details.scrollHeight : summary.offsetHeight;
  details.style.height = `${startHeight}px`;
  details.classList.add('is-animating');

  requestAnimationFrame(() => {
    details.style.height = `${endHeight}px`;
  });

  details.addEventListener(
    'transitionend',
    () => {
      details.classList.remove('is-animating');
      details.style.height = '';
      if (!isOpening) details.open = false;
    },
    { once: true }
  );
});
